import { create } from 'zustand'

/**
 * Search text survives tab switches — an engineer who searched "comrex",
 * tapped into the guide, and comes back should not have to retype. UI state
 * only; server data belongs to TanStack Query.
 *
 * `scope` is where to look (Charles, 2026-09-13): CDM Information and/or
 * the Session Log. Both on by default; at least one always stays on, so
 * a search can never quietly answer nothing because nowhere was ticked.
 */
export const SCOPES = ['info', 'log']

export const useSearchStore = create((set) => ({
  q: '',
  setQ: (q) => set({ q }),
  scope: { info: true, log: true },
  toggleScope: (key) =>
    set((s) => {
      const next = { ...s.scope, [key]: !s.scope[key] }
      return SCOPES.some((k) => next[k]) ? { scope: next } : {}
    }),
}))
